<template>
  <div>
    <app-header></app-header>
  <!-- Left side column. contains the logo and sidebar -->
  <aside class="main-sidebar">
    <!-- sidebar: style can be found in sidebar.less -->
    <section class="sidebar">
      <!-- Sidebar user panel -->
      <div class="user-panel">
        <div class="pull-left info">
        </div>
      </div>
      <!-- sidebar menu: : style can be found in sidebar.less -->

      <app-nav></app-nav>

    </section>
    <!-- /.sidebar -->
  </aside>

  <div class="main-content">
    <router-view></router-view>
  </div>

  <!-- /.content-wrapper -->
  <footer class="main-footer">
    <strong>Copyright &copy; 2017 <a href="https://www.nivi.io">NiVi</a>.</strong> All rights
    reserved.
  </footer>
  </div>
</template>

<script>
  import store from '../store';
  import Nav from './Nav';
  import Header from './Header';

  export default {
    name: 'app-dashboard',
    components: {
      'app-nav': Nav,
      'app-header': Header
    },

    beforeRouteEnter: async (to, from, next) => {
      const promises = [
        store.dispatch('loadCommonReplies'),
        store.dispatch('loadIntentMessages'),
        store.dispatch('loadKeywords')
      ];
      await Promise.all(promises);
      next();
    }
  };
</script>

<style>
  @import '../assets/css/main.css';
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue